"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequestPollingMode = void 0;
const react_1 = require("react");
const PollingModeManager_1 = require("../../core/managers/PollingModeManager");
/**
 * A React hook to request a specific polling mode and release it when the component is unmounted.
 *
 * When invoked, the hook automatically requests the specified polling mode for the component
 * and ensures that this mode is released when the component is unmounted or when a different
 * polling mode is requested. The hook uses a unique ID for each component instance to keep
 * track of the requested modes.
 *
 * @param pollingMode - The desired polling mode to be requested.
 *
 * @example
 * ```tsx
 * function MyComponent() {
 *     useRequestPollingMode(PollingMode.Callbacks);
 *
 *     // rest of the component
 * }
 * ```
 *
 * @returns {void}
 */
const useRequestPollingMode = (pollingMode) => {
    const id = (0, react_1.useId)();
    (0, react_1.useEffect)(() => {
        PollingModeManager_1.PollingModeManager.requestPollingMode(id, pollingMode);
        return () => {
            PollingModeManager_1.PollingModeManager.releasePollingMode(id);
        };
    }, [pollingMode]);
};
exports.useRequestPollingMode = useRequestPollingMode;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUmVxdWVzdFBvbGxpbmdNb2RlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2hvb2tzL3V0aWxpdHkvdXNlUmVxdWVzdFBvbGxpbmdNb2RlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw0REFBNEQ7OztBQUU1RCxpQ0FBeUM7QUFFekMsK0VBQTRFO0FBRTVFOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztHQW9CRztBQUNJLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxXQUF3QixFQUFFLEVBQUU7SUFDOUQsTUFBTSxFQUFFLEdBQUcsSUFBQSxhQUFLLEdBQUUsQ0FBQztJQUVuQixJQUFBLGlCQUFTLEVBQUMsR0FBRyxFQUFFO1FBQ1gsdUNBQWtCLENBQUMsa0JBQWtCLENBQUMsRUFBRSxFQUFFLFdBQVcsQ0FBQyxDQUFDO1FBRXZELE9BQU8sR0FBRyxFQUFFO1lBQ1IsdUNBQWtCLENBQUMsa0JBQWtCLENBQUMsRUFBRSxDQUFDLENBQUM7UUFDOUMsQ0FBQyxDQUFDO0lBQ04sQ0FBQyxFQUFFLENBQUMsV0FBVyxDQUFDLENBQUMsQ0FBQztBQUN0QixDQUFDLENBQUM7QUFWVyxRQUFBLHFCQUFxQix5QkFVaEMifQ==